/* Polsk katalog for locale-advisor-costs-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'adv.cost.review': 'Zobacz szczegóły',
  'adv.cost.moreTitle': 'Więcej możliwości',
  'adv.cost.observedValue': 'Zaobserwowana wartość',
  'adv.cost.invoiceBasis': 'Podstawa fakturowania',
  'adv.cost.draftValue': 'Wartość szkiców',
  'adv.cost.possibleCount': 'Możliwe duplikaty',
  'adv.cost.purchaseShare': 'Udział zakupów',
  'adv.cost.givenDiscount': 'Udzielony rabat',
  'adv.cost.unbilledNote': 'Podstawa fakturowania, nie zaksięgowany przychód',
  'adv.cost.draftNote': 'Wartość szkiców, nie zaksięgowany przychód',
  'adv.cost.acceptedNote': 'Zaakceptowane oferty bez powiązanej faktury',
  'adv.cost.duplicateNote': 'Możliwe duplikaty do sprawdzenia',
  'adv.cost.supplierNote': 'Wolumen zakupów, który może być podstawą do negocjacji',
  'adv.cost.discountTitle': 'Przejrzyj udzielone rabaty',
  'adv.cost.discountNote': 'Faktycznie udzielony rabat, nie wyliczona oszczędność',
  'adv.cost.voucherNote': 'Dokumentacja do uzupełnienia; brak wyliczonej oszczędności',
  'adv.cost.followUp': 'Do wyjaśnienia',
  'adv.cost.increaseToReview': 'Wzrost do sprawdzenia',
  'adv.cost.fixedTitle': 'Zaksięgowane koszty stałe',
  'adv.cost.tryAdjustment': 'Wypróbuj korektę',
  'adv.cost.fixedDetail': 'Średnio na miesiąc, na podstawie pełnych miesięcy: {months}',
  'adv.cost.otherTitle': 'Największe pozostałe konta kosztowe',
  'adv.cost.otherIntro': 'Udział pokazuje zaksięgowany koszt w stosunku do przychodów w wybranym roku. Nie jest to szacunek oszczędności, a konto nie jest automatycznie klasyfikowane jako zmienne.',
  'adv.cost.otherDetail': '{amount} zaksięgowano w wybranym roku',
  'adv.cost.ofRevenue': 'przychodów',
  'adv.cost.noRevenueShare': 'Udział nie został obliczony',
  'adv.cost.sub': 'Największe zaksięgowane konta kosztowe i zmiana względem poprzedniego roku',
  'adv.cost.subPeriod': 'Największe zaksięgowane konta kosztowe i zmiana względem tego samego okresu w poprzednim roku',
  'adv.cost.help': 'Konta pochodzą z rachunku zysków i strat za wybrany rok. Słupki pokazują zaksięgowaną kwotę na koncie. Zmiana jest pokazywana tylko wtedy, gdy to samo konto miało dodatnią kwotę w poprzednim roku.',
  'adv.cost.helpPeriod': 'Konta pochodzą z rachunku zysków i strat do bieżącego miesiąca włącznie. Słupki pokazują zaksięgowaną kwotę na koncie. Zmiana jest porównywana z tym samym okresem poprzedniego roku, gdy konto miało dodatnią kwotę.',
  'adv.cost.rowHelp': 'Zaksięgowano na koncie: {amount} w wybranym roku. Zmiana względem poprzedniego roku: {change}.',
  'adv.cost.noComparison': 'Brak danych z poprzedniego roku',
  'adv.cost.emptyText': 'Brak zaksięgowanych kont kosztowych w wybranym roku.',
  'adv.cost.flagText': '{name} znacznie wzrosło względem poprzedniego roku. Sprawdź, czy zmiana była planowana, i przejrzyj księgowania na koncie.',
  'adv.why.costSub': 'Konta kosztowe, które znacznie wzrosły względem poprzedniego roku',
});
